import {
  ACCOUNT_SUBSCRIPTIONS_ALL,
  ACCOUNT_SUBSCRIPTIONS_ALL_SUCCESS,
  ACCOUNT_SUBSCRIPTIONS_CANCEL,
  ACCOUNT_SUBSCRIPTIONS_CANCEL_SUCCESS,
  ACCOUNT_SUBSCRIPTIONS_CREATE,
  ACCOUNT_SUBSCRIPTIONS_CREATE_SUCCESS,
  ACCOUNT_SUBSCRIPTIONS_DELETE,
  ACCOUNT_SUBSCRIPTIONS_DELETE_SUCCESS,
  ACCOUNT_SUBSCRIPTIONS_GET,
  ACCOUNT_SUBSCRIPTIONS_GET_SUCCESS,
  ACCOUNT_SUBSCRIPTIONS_REACTIVATE,
  ACCOUNT_SUBSCRIPTIONS_REACTIVATE_SUCCESS,
  ACCOUNT_SUBSCRIPTIONS_UPDATE,
  ACCOUNT_SUBSCRIPTIONS_UPDATE_SUCCESS,
} from '../constants/AccountSubscriptions';

export const getAllAccountSubscriptions = () => ({
  type: ACCOUNT_SUBSCRIPTIONS_ALL,
});

export const getAllAccountSubscriptionsSuccess = (subscriptions) => ({
  type: ACCOUNT_SUBSCRIPTIONS_ALL_SUCCESS,
  subscriptions,
});

export const getAccountSubscription = () => ({
  type: ACCOUNT_SUBSCRIPTIONS_GET,
});

export const getAccountSubscriptionSuccess = (subscription) => ({
  type: ACCOUNT_SUBSCRIPTIONS_GET_SUCCESS,
  subscription,
});

export const createAccountSubscription = (data) => ({
  type: ACCOUNT_SUBSCRIPTIONS_CREATE,
  data,
});

export const createAccountSubscriptionSuccess = (subscription) => ({
  type: ACCOUNT_SUBSCRIPTIONS_CREATE_SUCCESS,
  subscription,
});

export const updateAccountSubscription = (id, data) => ({
  type: ACCOUNT_SUBSCRIPTIONS_UPDATE,
  id,
  data,
});

export const updateAccountSubscriptionSuccess = (subscription) => ({
  type: ACCOUNT_SUBSCRIPTIONS_UPDATE_SUCCESS,
  subscription,
});

export const deleteAccountSubscription = (id, history) => ({
  type: ACCOUNT_SUBSCRIPTIONS_DELETE,
  id,
  history,
});

export const deleteAccountSubscriptionSuccess = () => ({
  type: ACCOUNT_SUBSCRIPTIONS_DELETE_SUCCESS,
});

export const cancelAccountSubscription = (id, reason) => ({
  type: ACCOUNT_SUBSCRIPTIONS_CANCEL,
  id,
  reason,
});

export const cancelAccountSubscriptionSuccess = () => ({
  type: ACCOUNT_SUBSCRIPTIONS_CANCEL_SUCCESS,
});

export const reactivateAccountSubscription = (id) => ({
  type: ACCOUNT_SUBSCRIPTIONS_REACTIVATE,
  id,
});

export const reactivateAccountSubscriptionSuccess = () => ({
  type: ACCOUNT_SUBSCRIPTIONS_REACTIVATE_SUCCESS,
});